<template>
    <div class="ScenarioCard">
        <v-layout align-center class="ScenarioCardHeader">
            <v-layout align-center class="ScenarioCardName">
                <template v-if="nameEditable && editName">
                    <input type="text" v-model="nameValue" class="name-editor" ref="editName">
                    <v-icon class="btn-icon-2" @click="updateNameCard" size="20">mdi-check</v-icon>
                </template>
                <template v-else>
                    <span>{{ nameValue }}</span>
                    <div class="btn-icon-2 ml-6" @click="showEditName" v-if="nameEditable">
                        <img src="/img/edit.svg" alt="icon-edit">
                    </div>
                </template>
            </v-layout>
            <v-spacer></v-spacer>
            <template v-if="moveAble">
                <v-icon class="btn-icon-2" @click="moveUp" size="22">mdi-chevron-up</v-icon>
                <v-icon class="btn-icon-2" @click="moveDown" size="22">mdi-chevron-down</v-icon>
            </template>
            <div class="btn-icon-2" style="background: #e5e5e5;" @click="deleteCard" v-if="deleteAble">
                <img src="/img/scenario/close-fill.svg" alt="icon-delete">
            </div>
        </v-layout>
        <div class="ScenarioCardBody">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ScenarioCard',
    props: {
        name: String,
        moveAble: Boolean,
        nameEditable: Boolean,
        deleteAble: Boolean,
        icon: String,
        nameInvalid: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            editName: '',
            nameValue: '',
            oldNameValue: '',
        }
    },
    methods: {
        deleteCard () {
            this.$emit('delete')
        },
        moveUp () {
            this.$emit('moveUp')
        },
        moveDown () {
            this.$emit('moveDown')
        },
        showEditName () {
            this.editName = true
            this.$nextTick(() => {
                this.$refs.editName.focus()
                this.$refs.editName.select()
            })
        },
        updateNameCard () {
            if (this.nameInvalid.includes(this.nameValue.trim())) {
                this.$appService.toastError(this.$f.tc('invalidNameCard'))
                this.nameValue = this.oldNameValue
                this.editName = false
                return
            }

            this.editName = false
            if (this.oldNameValue !== this.nameValue) {
                this.oldNameValue = this.nameValue
                this.$emit('updateCardName', this.nameValue)
            }
        },
    },
    watch: {
        name: {
            immediate: true,
            handler: function (name) {
                this.nameValue = name
                this.oldNameValue = name
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioCard {
    padding-top: 12px;
    z-index: 1;
    font-size: 14px !important;
    font-family: "open sans", serif;
    position: relative;
}

.ScenarioCard:last-child {
    margin-bottom: 55px;
}

.ScenarioCardHeader {
    height: 40px;
    padding: 0 6px 0 12px;
    background: #F2F2F2;
    font-family: "open sans semi", serif;
    border-radius: 5px 5px 0 0;
    border: 1px solid #D9D9D9;
    border-bottom: none;

    ::v-deep {
        input {
            background: #FFFFFF;
            padding: 3px 6px;
            outline-style: solid;
            outline-width: 1px !important;
            outline-color: #F2F2F2;
            border-radius: 5px;
        }
    }
}

.ScenarioCardBody {
    border: 1px solid #D9D9D9;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 12px;
    background: #fff;
}

.btn-icon-2 {
    margin-left: 2px;
    width: 26px;
    height: 26px;
}

.ScenarioCardName {
    display: flex;

    span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        font-family: "open sans bold", serif;
    }

}
</style>
